import React, { useState } from "react";
import { config } from "../utils/config";
import { useNavigate } from "react-router-dom";
import { getSubscriptionStatus, submitUserPlans } from "../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../redux/slices/UserSlice";
import { setPlanDetails, setVariationCountDetails } from "../redux/slices/PlanDetailSlice";

export default function PlansList({ yearly, plansList }) {
  const initialUserPlanDetails = localStorage.getItem(config.USER_PLAN_DETAILS);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let user =
    localStorage.getItem(config.USER_LOGIN_DETAILS) &&
    JSON.parse(localStorage.getItem(config.USER_LOGIN_DETAILS));


  const userPlanDetails = useSelector((state) => state?.userPlan?.userPlanDetails?.[0]);
  console.log("deepak userplandetails ",userPlanDetails)
  const userVariants = useSelector(state => state?.userPlan?.variants);

  const submitUserPlan = async (planid) => {
    try {
      let response = await submitUserPlans(planid, user);
      if (response && +response?.resultFlag === 1) {
        localStorage.removeItem("users_email");
        let details = response?.response?.user_data;
        let userPlan = response?.response?.userPlan;
        let variant = response?.response?.variants;
        if (variant) {
          localStorage.setItem(config.VARIANT_COUNT, JSON.stringify(variant));
        }
        localStorage.setItem(
          config.USER_LOGIN_DETAILS,
          JSON.stringify(details)
        );
        localStorage.setItem(
          config.USER_PLAN_DETAILS,
          JSON.stringify(userPlan)
        );
        dispatch(setUserData({ userData: details }))
        dispatch(setPlanDetails({ userPlanDetails: userPlan }))
        dispatch(setVariationCountDetails(variant))
        if (initialUserPlanDetails) {
          navigate("/profile?plan=" + planid);
        } else {
          navigate("/profile?plan=" + planid + "&ftime=1");
        }
      } else {
      }
    } catch (error) { }
  };


  const getCurrentPlanOrSubscribe = (id) => {

    let isCurrentPlan = false;
    let showAddOn = false;
    let isExpired = false;

    if (userPlanDetails?.type === "Free" || userPlanDetails?.type === "Prepaid") {
      let count = parseInt(userVariants?.total_variant) - parseInt(userVariants?.variant_count);
      if (count > 0) {
        isCurrentPlan = true;

        if (userPlanDetails?.type === "Prepaid") {
          showAddOn = true;
        }

      }
      else {
        isCurrentPlan = false;
      }
    }
    else {
      const status = getSubscriptionStatus(userPlanDetails);
      if (status === "Subscription expired") {
        isCurrentPlan = false;
        isExpired = true;
      }
      else {
        isCurrentPlan = true;
      }
    }


    // check with id 
    if (+userPlanDetails?.plan_id == +id) {
      isCurrentPlan = true;
    }
    else {
      isCurrentPlan = false;
    }
    // end


    // if (isCurrentPlan && !showAddOn && !isExpired) {
    //   return (
    //     <button className="btn btn-secondary current-plan" disabled>
    //       Current Plan
    //     </button>
    //   )
    // }


    if (showAddOn && isCurrentPlan) {
      return (
        <button className="btn btn-secondary" style={{
          backgroundColor: "#0e2251",
          color: "#fff",
        }}
          onClick={() => planClickHandler(id)}>
          Buy Now
        </button>
      )
    }

    return (
      <button
        className={"subbtn_bg"}
        onClick={() => planClickHandler(id)}
      >
        {" "}
        Subscribe Now
      </button>
    )



  }

  const planClickHandler = async (id) => {
    const loginUser = localStorage.getItem(config.USER_LOGIN_DETAILS)
      ? JSON.parse(localStorage.getItem(config.USER_LOGIN_DETAILS))
      : null;
    if (!loginUser) {
      navigate("/Login?plan=" + id);
    } else {
      if (id == "1" || id == "2") {
        await submitUserPlan(id);
      } else {
        navigate("/payment?plan=" + id);
      }
    }
  };



  const CurrentPlanTag = () => {
    return (
      <div style={{
        font: "normal normal medium 14px/18px IBM Plex Sans",
        backgroundColor: "#9ef08f",
        color: "#135008",
        padding: "0.34vw 0.54vw",
        borderBottomLeftRadius: "12px",
        borderBottomRightRadius: "12px",
        position: "relative",
        width: "110px",
        top: -33,
        left: 230,
        fontWeight: 500,
        textAlign: "center"
      }}>
        Current Plan
      </div>
    )
  }


  return (
    <>
      <div className="row row_sub_flex">

        {plansList?.length > 0 &&
          plansList?.map((item) => {
            let btnText =
              item?.type === "Free"
                ? "Start Free Trial!"
                : item?.type === "PPV"
                  ? "Get Started"
                  : "Subscribe Now";
            let btnClass = item?.type === "Unlimited" ? "subbtn_bg" : "subbtn_bg";
            let firstLine = "";
            if (item?.id == "1") {
              firstLine = `<div class="subpoint_list">
              <ul>
                <li>
                  <img src="/assets/images/check.svg" alt="" />
                </li>
                <li>
                  <p>Full access to design tools and features.</p>
                </li>
              </ul>
        
              <ul>
                <li>
                  <img src="/assets/images/warning.svg" alt="" />
                </li>
                <li>
                  <p>Limited to 100 variations during the trial period.</p>
                </li>
              </ul>
        
              <!-- <ul>
                <li>
                  <img src="/assets/images/warning.svg" alt="" />
                </li>
                <li>
                  <p>Experience the software for 2 days.</p>
                </li> 
              </ul> -->
            </div>`;
            } else if (item?.id == "2" || item?.id == "5") {
              firstLine = ` <div class="subpoint_list">
              <ul>
                <li>
                  <img src="/assets/images/check.svg" alt="" />
                </li>
                <li>
                  <p>Full access to design tools and features.</p>
                </li>
              </ul>
        
              <ul>
                <li>
                  <img src="/assets/images/warning.svg" alt="" />
                </li>
                <li>
                  <p>Pay only for the actual number of Variations created.</p>
                </li>
              </ul>
        
              <ul>
                <li>
                  <img src="/assets/images/warning.svg" alt="" />
                </li>
                <li>
                  <p>Pay as you use. </p>
                </li>
              </ul>
            </div>`;
            } else {
              firstLine = `<div class="subpoint_list">
              <ul>
                <li>
                  <img src="/assets/images/check.svg" alt="" />
                </li>
                <li>
                  <p>Full access to design tools and features.</p>
                </li>
              </ul>
        
              <ul>
                <li>
                  <img src="/assets/images/check.svg" alt="" />
                </li>
                <li>
                  <p>Unlimited Creations can be created For single user</p>
                </li>
              </ul>
        
              <ul>
                <li>
                  <img src="/assets/images/check.svg" alt="" />
                </li>
                <li>
                  <p>
                    Experience the software with no commitment for 28 days.
                  </p>
                </li>
              </ul>
            </div>`;
            }
            if (yearly && item?.id != "6") {
              return (
                <div className="col-xl-3 col-sm-5">
                  <div className="sub_pos">
                    <img
                      src={`${config.s3BaseUrl}/images/gradcard.png`}
                      className="card_activegrad"
                      alt=""
                    />
                    <div className="sub_card">
                      <div className="sub_trail_flex">


                        {userPlanDetails?.plan_id == item?.id && <CurrentPlanTag />}


                        <div className="trail_head">
                          <h4>{item?.name}</h4>
                          <h6>{item?.title}</h6>
                        </div>

                        <div className="trail_price">
                          <h3>
                            <sup>₹</sup>
                            {item?.price}{" "}
                            <sub>
                              /{item?.days}{" "}
                              {item?.id == 2
                                ? "per Variation Created"
                                : item?.id == 5
                                  ? "per variation"
                                  : "Days"}
                            </sub>
                          </h3>
                          {initialUserPlanDetails ? (
                            //check if current id is same as userplan id
                            item?.id ==
                              JSON.parse(initialUserPlanDetails)?.plan_id ? (
                              JSON.parse(
                                localStorage.getItem(config.USER_LOGIN_DETAILS)
                              )?.plan_status !== "active" ? getCurrentPlanOrSubscribe(item?.id) : JSON.parse(
                                localStorage.getItem(config.USER_PLAN_DETAILS)
                              )?.variant_count > 19 ? getCurrentPlanOrSubscribe(item?.id) : (
                                getCurrentPlanOrSubscribe(item?.id)
                              )
                            ) : //check if userplan id is greater than 1 in that case 1 should be expired
                              JSON.parse(initialUserPlanDetails)?.plan_id > "1" &&
                                item?.id == "1" ? (
                                <button disabled className="btn btn-secondary">
                                  {" "}
                                  Expired
                                </button>
                              ) : (
                                <button
                                  className={btnClass}
                                  onClick={() => planClickHandler(item?.id)}
                                >
                                  {" "}
                                  {btnText}
                                </button>
                              )
                          ) : (
                            <button
                              className={btnClass}
                              onClick={() => planClickHandler(item?.id)}
                            >
                              {" "}
                              {btnText}
                            </button>
                          )}
                        </div>
                      </div>

                      <div
                        dangerouslySetInnerHTML={{ __html: firstLine }}
                      ></div>
                    </div>
                  </div>
                </div>
              );
            } else if (!yearly && item?.id != "7") {
              return (
                <div className="col-xl-3 col-sm-5">
                  <div className="sub_pos">
                    <img
                      src={`${config.s3BaseUrl}/images/gradcard.png`}
                      className="card_activegrad"
                      alt=""
                    />
                    <div className="sub_card">
                      <div className="sub_trail_flex">

                      {userPlanDetails?.plan_id == item?.id && <CurrentPlanTag />}

                        <div className="trail_head">
                          <h4>{item?.name}</h4>
                          <h6>{item?.title}</h6>
                        </div>

                        <div className="trail_price">
                          <h3>
                            <sup>₹</sup>
                            {item?.price}{" "}
                            <sub>
                              /{item?.days}{" "}
                              {item?.id == 2
                                ? "per Variation Created"
                                : item?.id == 5
                                  ? "per variation"
                                  : "Days"}
                            </sub>
                          </h3>
                          {initialUserPlanDetails ? (
                            //check if current id is same as userplan id
                            item?.id ==
                              JSON.parse(initialUserPlanDetails)?.plan_id ? (
                              JSON.parse(
                                localStorage.getItem(config.USER_LOGIN_DETAILS)
                              )?.plan_status !== "active" ? getCurrentPlanOrSubscribe(item?.id) : JSON.parse(
                                localStorage.getItem(config.USER_PLAN_DETAILS)
                              )?.variant_count > 19 ? (
                                getCurrentPlanOrSubscribe(item?.id)
                              ) : (
                                getCurrentPlanOrSubscribe(item?.id)
                              )
                            ) : //check if userplan id is greater than 1 in that case 1 should be expired
                              JSON.parse(initialUserPlanDetails)?.plan_id > "1" &&
                                item?.id == "1" ? (
                                <button disabled className="btn btn-secondary">
                                  {" "}
                                  Expired
                                </button>
                              ) : (
                                <button
                                  className={btnClass}
                                  onClick={() => planClickHandler(item?.id)}
                                >
                                  {" "}
                                  {btnText}
                                </button>
                              )
                          ) : (
                            <button
                              className={btnClass}
                              onClick={() => planClickHandler(item?.id)}
                            >
                              {" "}
                              {btnText}
                            </button>
                          )}
                        </div>
                      </div>

                      <div
                        dangerouslySetInnerHTML={{ __html: firstLine }}
                      ></div>
                    </div>
                  </div>
                </div>
              );
            } else {
              return <></>;
            }
          })}
      </div>
    </>
  );
}
